import category from './category';
import defaultRoutes from './defaultRoutes';

const routes = [
    ...defaultRoutes,
    ...category
];

export default routes;